import React from "react";
import moment from "moment";
import { Grid2 as Grid, MenuItem, TextField } from "@mui/material";
import MultipleSelect from "../../components/MultipleSelect/MultipleSelect";

const IncidentForm = ({
  formValues,
  handleChange,
  errors,
  readOnly = false,
}) => {
  const categories = [
    "Unauthorized Access",
    "Unauthorized Use",
    "Unauthorized Modification",
    "Destruction",
    "Denial of Access",
    "Disclosure of Information",
    "Social Engineering",
    "Other",
  ];

  const detectionSources = [
    "IDS/IPS",
    "SIEM",
    "Antivirus",
    "Email Security Gateway",
    "EDR",
    "NDR",
    "Network Flow",
    "Content  Web Filtering",
    "File Integrity Monitoring",
    "Operating system Logs",
    "Application Logs",
    "Virtualized Environment Logs",
    "Database Logs",
    "Third Party Monitoring Services",
    "Network device logs",
    "Security Operating Center",
    "People from within the organization",
    "People from outside the organization",
    "Other(Please specify)",
  ];

  const financialImpacts = [
    "Direct Loss  (Financial loss direct  due to cyber criminal  act)",
    "Loss of revenue (The amount loss due to the downtime caused by the incident)",
    "Penalties or fines (Due to the failure to meet regulatory requirements)",
    "Compensation (Amount paid to the third parties due to the failure of meeting contractual or SLA obligations)",
  ];

  const nonFinancialImpacts = [
    "Corporate objectives (Failure to achieve Corporate objectives)",
    "Public image (Loss of reputation to the public)",
    "Legal and or compliance (Exposure to be sued or penalties due to contract entered or regulatory body)",
    "Customer Satisfaction (Inability to maintain Customer Satisfaction)",
    "Data Breach (Loss of Confidentiality, Integrity or Availability)",
  ];

  const ratings = ["High", "Medium", "Low"];

  const statuses = ["Open", "Work in progress", "Closed"];

  const tlpStatuses = [
    { value: "Red", description: "Red" },
    { value: "Amber", description: "Amber" },
    { value: "Green", description: "Green" },
    { value: "White", description: "White" },
  ];

  //builders
  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 6, xs: 12 }}>
        <TextField
          disabled={readOnly}
          required
          fullWidth
          variant="outlined"
          name="incidentCategory"
          id="incident-category"
          select
          label="Incident Category"
          error={errors["incidentCategory"] ? true : false}
          helperText={
            errors["incidentCategory"] ? errors.incidentCategory[0] : null
          }
          onChange={handleChange}
          value={formValues?.incidentCategory}
        >
          {categories.map((option) => {
            return <MenuItem value={option}>{option}</MenuItem>;
          })}
        </TextField>
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <TextField
          disabled={readOnly}
          fullWidth
          required
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: {
              max: moment().format("YYYY-MM-DD"), // Disallows future dates
            },
          }}
          variant="outlined"
          type="date"
          name="incidentDate"
          error={errors["incidentDate"] ? true : false}
          helperText={errors["incidentDate"] ? errors.incidentDate[0] : null}
          id="incident-date"
          label="Incident Date"
          onChange={handleChange}
          value={formValues?.incidentDate}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          fullWidth
          disabled={readOnly}
          required
          multiline
          rows={readOnly ? 15 : 5}
          variant="outlined"
          type="text"
          name="incidentDescription"
          id="incident-description"
          label="Incident Description"
          error={errors["incidentDescription"] ? true : false}
          helperText={
            errors["incidentDescription"] ? errors.incidentDescription[0] : null
          }
          onChange={handleChange}
          value={formValues?.incidentDescription}
        />
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <TextField
          required
          disabled={readOnly}
          fullWidth
          variant="outlined"
          name="incidentRating"
          id="incident-rating"
          select
          label="Incident Rating"
          error={errors["incidentRating"] ? true : false}
          helperText={
            errors["incidentRating"] ? errors.incidentRating[0] : null
          }
          onChange={handleChange}
          value={formValues?.incidentRating}
        >
          {ratings.map((option) => {
            return <MenuItem value={option}>{option}</MenuItem>;
          })}
        </TextField>
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <TextField
          required
          disabled={readOnly}
          fullWidth
          variant="outlined"
          name="tlpStatus"
          id="tlp-statuses"
          select
          label="TLP Status"
          error={errors["tlpStatus"] ? true : false}
          helperText={errors["tlpStatus"] ? errors.tlpStatus[0] : null}
          onChange={handleChange}
          value={formValues?.tlpStatus}
        >
          {tlpStatuses.map((option) => {
            return <MenuItem value={option.value}>{option.value}</MenuItem>;
          })}
        </TextField>
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <TextField
          required
          disabled={readOnly}
          fullWidth
          variant="outlined"
          name="incidentStatus"
          id="incident-status"
          select
          error={errors["incidentStatus"] ? true : false}
          helperText={
            errors["incidentStatus"] ? errors.incidentStatus[0] : null
          }
          label="Incident Status"
          onChange={handleChange}
          value={formValues?.incidentStatus}
        >
          {statuses.map((option) => {
            return <MenuItem value={option}>{option}</MenuItem>;
          })}
        </TextField>
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <TextField
          fullWidth
          disabled={readOnly}
          required
          variant="outlined"
          type="email"
          name="contactEmail"
          id="contact-email"
          label="Your Contact Email"
          error={errors["contactEmail"] ? true : false}
          helperText={errors["contactEmail"] ? errors.contactEmail[0] : null}
          onChange={handleChange}
          value={formValues?.contactEmail}
        />
      </Grid>

      {formValues?.incidentStatus === "Closed" && (
        <>
          <Grid size={{ md: 6, xs: 12 }}>
            <TextField
              fullWidth
              disabled={readOnly}
              required
              variant="outlined"
              type="text"
              name="causeOfIncident"
              id="incident-cause"
              label="Cause of Incident"
              error={errors["causeOfIncident"] ? true : false}
              helperText={
                errors["causeOfIncident"] ? errors.causeOfIncident[0] : null
              }
              onChange={handleChange}
              value={formValues?.causeOfIncident}
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TextField
              fullWidth
              disabled={readOnly}
              variant="outlined"
              type="text"
              required
              name="incidentLocation"
              id="incident-location"
              label="Incident Location"
              error={errors["incidentLocation"] ? true : false}
              helperText={
                errors["incidentLocation"] ? errors.incidentLocation[0] : null
              }
              onChange={handleChange}
              value={formValues?.incidentLocation}
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TextField
              fullWidth
              disabled={readOnly}
              required
              variant="outlined"
              type="text"
              name="systemsImpacted"
              id="systems-impacted"
              label="Systems / Services Impacted"
              error={errors["systemsImpacted"] ? true : false}
              helperText={
                errors["systemsImpacted"] ? errors.systemsImpacted[0] : null
              }
              onChange={handleChange}
              value={formValues?.systemsImpacted}
            />
          </Grid>
          <Grid size={12}>
            {/* <TextField
              fullWidth
              disabled={readOnly}
              required
              variant="outlined"
              type="text"
              name="sourceOfDetection"
              id="systems-impacted"
              label="Source of Detection"
              error={errors["sourceOfDetection"] ? true : false}
              helperText={
                errors["sourceOfDetection"] ? errors.sourceOfDetection[0] : null
              }
              onChange={handleChange}
              value={formValues?.sourceOfDetection}
            /> */}
            <MultipleSelect
              disabled={readOnly}
              required={true}
              options={detectionSources}
              formValues={formValues}
              onChange={handleChange}
              errors={errors}
              label="Source(s) of Detection"
              name="sourceOfDetection"
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              disabled={readOnly}
              variant="outlined"
              type="text"
              name="financialImpact"
              id="financial-impact"
              label="Financial Impact"
              error={errors["financialImpact"] ? true : false}
              helperText={
                errors["financialImpact"] ? errors.financialImpact[0] : null
              }
              onChange={handleChange}
              value={formValues?.financialImpact}
            />
          </Grid>
          <Grid size={12}>
            {/* <TextField
              fullWidth
              disabled={readOnly}
              variant="outlined"
              type="text"
              name="nonFinancialImpact"
              id="non-financial-impact"
              label="Non-Financial Impact"
              error={errors["nonFinancialImpact"] ? true : false}
              helperText={
                errors["nonFinancialImpact"]
                  ? errors.nonFinancialImpact[0]
                  : null
              }
              onChange={handleChange}
              value={formValues?.nonFinancialImpact}
            /> */}
            <MultipleSelect
              disabled={readOnly}
              required={false}
              options={nonFinancialImpacts}
              formValues={formValues}
              onChange={handleChange}
              errors={errors}
              label="Non Financial Impact"
              name="nonFinancialImpact"
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TextField
              fullWidth
              disabled={readOnly}
              variant="outlined"
              type="text"
              required
              name="measuresTaken"
              id="measures-taken"
              label="Measures Taken"
              error={errors["measuresTaken"] ? true : false}
              helperText={
                errors["measuresTaken"] ? errors.measuresTaken[0] : null
              }
              onChange={handleChange}
              value={formValues?.measuresTaken}
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TextField
              fullWidth
              disabled={readOnly}
              variant="outlined"
              type="text"
              required
              name="lessonsLearned"
              id="lessons-learned"
              label="Lessons Learned"
              error={errors["lessonsLearned"] ? true : false}
              helperText={
                errors["lessonsLearned"] ? errors.lessonsLearned[0] : null
              }
              onChange={handleChange}
              value={formValues?.lessonsLearned}
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TextField
              fullWidth
              disabled={readOnly}
              variant="outlined"
              type="text"
              name="namesOfPersonsInvolved"
              id="names-of-persons-involved"
              placeholder="eg: John Doe, Jane Roe"
              label="Names of Persons Involved"
              error={errors["namesOfPersonsInvolved"] ? true : false}
              helperText={
                errors["namesOfPersonsInvolved"]
                  ? errors.namesOfPersonsInvolved[0]
                  : null
              }
              onChange={handleChange}
              value={formValues?.namesOfPersonsInvolved}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default IncidentForm;
